import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import type { HeroContent } from '../types';

interface HeroSectionProps {
  content: HeroContent;
  onPrimaryCTA: () => void;
  onSecondaryCTA: () => void;
}

const HeroSection = ({ content, onPrimaryCTA, onSecondaryCTA }: HeroSectionProps) => {
  const handleTestClick = () => {
    window.open('https://t.me/Aidating_love7_bot?start=002_res', '_blank');
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-primary/5 via-background to-accent/5 overflow-hidden">
      {/* Festive floating hearts animation */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 text-red-400/20 animate-float-slow">
          <Icon name="Heart" size={48} />
        </div>
        <div className="absolute top-40 right-20 text-pink-400/20 animate-float-delay">
          <Icon name="Heart" size={32} />
        </div>
        <div className="absolute bottom-32 left-1/4 text-red-300/20 animate-float-slow">
          <Icon name="Heart" size={40} />
        </div>
        <div className="absolute top-1/3 right-1/4 text-pink-300/20 animate-float">
          <Icon name="Sparkles" size={36} />
        </div>
      </div>

      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(37,99,235,0.1),transparent_50%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_50%,rgba(249,115,22,0.1),transparent_50%)]" />
      
      <div className="relative max-w-content mx-auto px-4 sm:px-6 py-20 sm:py-32">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="text-center lg:text-left space-y-8 order-2 lg:order-1">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full text-primary text-sm font-medium">
              <Icon name="Sparkles" size={16} className="animate-pulse" />
              <span>Социальная инженерия + ИИ + Цифровые двойники</span>
              <Icon name="Heart" size={16} className="text-red-500 animate-pulse" />
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground leading-tight">
              {content.headline}
            </h1>

            <p className="text-lg sm:text-xl text-secondary max-w-2xl">
              Пройдите бесплатное тестирование 7 каналов мышления и создайте цифровой двойник для автоматического поиска наилучшей пары.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button
                variant="default"
                size="lg"
                iconName="Brain"
                iconPosition="right"
                onClick={handleTestClick}
                className="text-base font-semibold">
                {content.primaryCTA}
              </Button>

              <Button
                variant="outline"
                size="lg"
                iconName="ArrowDown"
                iconPosition="right"
                onClick={onSecondaryCTA}
                className="text-base font-semibold">

                {content.secondaryCTA}
              </Button>
            </div>

            <div className="flex items-center gap-6 justify-center lg:justify-start pt-4">
              <div className="flex -space-x-2">
                {[1, 2, 3, 4].map((i) =>
                <div
                  key={i}
                  className="w-10 h-10 rounded-full border-2 border-background bg-gradient-to-br from-primary to-accent flex items-center justify-center text-white text-xs font-bold">

                    {i}
                  </div>
                )}
              </div>
              <div className="text-sm text-secondary">
                <div className="font-semibold text-foreground">500+ пар</div>
                <div>уже нашли друг друга</div>
              </div>
            </div>
          </div>

          <div className="relative order-1 lg:order-2">
            <div className="relative aspect-square rounded-2xl overflow-hidden shadow-2xl">
              <Image
                src="https://img.rocket.new/generatedImages/rocket_gen_img_17870bc04-1765309457079.png"
                alt="Romantic couple embracing and smiling together, representing successful AI-powered matchmaking and authentic love connection"
                className="w-full h-full object-cover" />

              <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent" />
              
              {/* Festive sparkles overlay */}
              <div className="absolute top-4 right-4 text-yellow-300 animate-pulse">
                <Icon name="Sparkles" size={32} />
              </div>
              <div className="absolute bottom-4 left-4 text-pink-300 animate-pulse animation-delay-500">
                <Icon name="Heart" size={28} />
              </div>
            </div>

            <div className="absolute -top-4 -right-4 w-24 h-24 bg-accent rounded-full blur-3xl opacity-50 animate-pulse" />
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-primary rounded-full blur-3xl opacity-50 animate-pulse animation-delay-1000" />
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;